import React, { forwardRef } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";

import SoftInput from "../SoftInput";
import SoftBox from "../SoftBox";
import SoftTypography from "../SoftTypography";

// eslint-disable-next-line react/display-name
const TextInputField = forwardRef(({ name, label, ...rest }, ref) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <SoftBox
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            height="100%"
            mb={1.5}
          >
            {label && (
              <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  textTransform="capitalize"
                >
                  {label}
                </SoftTypography>
              </SoftBox>
            )}
            <SoftInput {...field} {...rest} error={Boolean(error || rest.error)} ref={ref} />
            {error && (
              <SoftBox mt={0.75}>
                <SoftTypography component="div" variant="caption" color="error">
                  {_.get(error, "message", "Unknown error")}
                </SoftTypography>
              </SoftBox>
            )}
          </SoftBox>
        );
      }}
    />
  );
});

// Setting default values for the props of SoftInput
TextInputField.defaultProps = {
  label: "",
  error: false,
};

// Typechecking props for the SoftInput
TextInputField.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

export default TextInputField;
